import { defineMessages } from "react-intl";
const localized = defineMessages({
  infoMessage: {
    id: "infoMessage",
    defaultMessage: "Something went wrong."
  },
  showMoreLabel: {
    id: "showMoreLabel",
    defaultMessage: "More info"
  }
});
export {
  localized
};
//# sourceMappingURL=localize.js.map
